import { Component } from '@angular/core';
import { IMedicationStatement } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractDetailsComponent } from '../../../../shared/abstracts/details/abstract-details/abstract-details.component';

@Component({
  selector: 'inc-medication-details',
  templateUrl: './medication-details.component.html',
  styleUrls: ['./medication-details.component.scss'],
})
export class MedicationDetailsComponent extends AbstractDetailsComponent<IMedicationStatement> {
  constructor() { super(); }
}
